import { useAuth } from "@/context/AuthContext";

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const len = (s) => {
  const a = +s.start.slice(0, 2) * 60 + +s.start.slice(3), b = +s.end.slice(0, 2) * 60 + +s.end.slice(3);
  return ((b - a + 1440) % 1440 || 1440) / 60;
};

export const RosterPrint = ({ days, members, shifts, wps }) => {
  const { business } = useAuth();
  const wpName = (id) => wps.find((w) => w.workplace_id === id)?.name;
  const rows = members.filter((m) => m.role !== "owner" || shifts.some((s) => s.membership_id === m.membership_id));
  const fmt = (d, o) => d.toLocaleDateString("en-AU", o);
  return (
    <div id="roster-print" className="hidden" data-testid="roster-print">
      <div className="rp-head">
        <div><p className="rp-biz">{business?.name}</p><p className="rp-title">Staff roster · {fmt(days[0], { day: "numeric", month: "short" })} – {fmt(days[6], { day: "numeric", month: "short", year: "numeric" })}</p></div>
        <p className="rp-meta">Printed {new Date().toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" })}</p>
      </div>
      <table className="rp-table">
        <thead><tr><th className="rp-name">Employee</th>{days.map((d) => <th key={iso(d)}>{fmt(d, { weekday: "short" })}<br /><span>{fmt(d, { day: "numeric", month: "short" })}</span></th>)}<th className="rp-total">Hrs</th></tr></thead>
        <tbody>{rows.map((m) => {
          const mine = shifts.filter((s) => s.membership_id === m.membership_id);
          return (
            <tr key={m.membership_id}>
              <td className="rp-name">{m.name}</td>
              {days.map((d) => (
                <td key={iso(d)}>{mine.filter((s) => s.date === iso(d)).map((s) => (
                  <div key={s.roster_shift_id} className="rp-shift"><b style={s.response === "declined" ? { textDecoration: "line-through" } : undefined}>{s.start}–{s.end}</b>{wpName(s.workplace_id) && <span>{wpName(s.workplace_id)}</span>}{!s.published && <i>draft</i>}{s.response === "declined" && <i>declined</i>}</div>))}</td>
              ))}
              <td className="rp-total">{mine.filter((s) => s.response !== "declined").reduce((t, s) => t + len(s), 0) || ""}</td>
            </tr>);
        })}</tbody>
      </table>
    </div>
  );
};
